import React, { useMemo, useState } from 'react'

import { SStyled } from 'styles/theme'
import SBox from './SBox'

import SInputLabel from './SInputLabel'
import { SxStyleProp } from 'rebass'

interface Props {
    children?: React.ReactNode
    content: any
    sx?: SxStyleProp
    sy?: SxStyleProp
    tooltipImage?: string
}

const TooltipContent = SStyled(SInputLabel)`
    background: white;
    margin: auto;
    border: 1px solid #A0A0A0;
    border-radius: 10px;
    padding: 5px;

    @media screen and (max-width: ${(p) => p.theme.breakpoints[0]}) {
        width: 100%;
    }
`

const TooltipWrapper = SStyled(SBox)`
    @media screen and (max-width: ${(p) => p.theme.breakpoints[0]}) {
        width: 20%;
    }
`
let timeout = undefined

const STooltip: React.FC<Props> = (props: Props) => {
    const { sx, sy = {} } = props
    const [active, setActive] = useState(false)
    const [positionX, setPositionX] = useState(null)

    const showTip = (e) => {
        setPositionX(e.clientX)
        if (!timeout) {
            timeout = setTimeout(() => {
                setActive(true)
            }, 300)
        }
    }
    const hideTip = () => {
        timeout = clearTimeout(timeout)
        setActive(false)
    }

    // DO NOT TOUCH THIS FUNCTION (Ask Alex / Donca)
    const absolutePositioningStyle = useMemo(() => {
        const minWidth = props.tooltipImage ? 260 : 200
        const windowWidth = window.innerWidth
        const diff = windowWidth - positionX - minWidth

        if (diff < 0) {
            return {
                right: '-30px',
                top: '5px',
            }
        } else {
            return {
                left: 0,
                top: '5px',
            }
        }
    }, [active, positionX])

    return (
        <a onClick={showTip} onMouseLeave={hideTip}>
            <TooltipWrapper
                className="Tooltip-Wrapper"
                onMouseOver={showTip}
                onMouseLeave={hideTip}
                sx={{
                    position: 'relative',
                    height: '16px',
                    width: '4%',
                    ...sy,
                }}
            >
                <img
                    style={{ textAlign: 'center', marginRight: '10px', width: '15px', height: '15px' }}
                    src="/tooltip-q-mark.svg"
                    alt="tooltip-image"
                />
                {props.children}
                {active && (
                    <TooltipContent
                        sx={{
                            position: 'absolute',
                            width: 'fit-content',
                            minWidth: props.tooltipImage ? '260px' : '200px',
                            height: 'fit-content',
                            ...absolutePositioningStyle,
                            ...sx,
                        }}
                        className={`Tooltip`}
                        style={{ zIndex: 100 }}
                    >
                        {!props.tooltipImage && <span dangerouslySetInnerHTML={{ __html: props.content }}></span>}
                        {props.tooltipImage && (
                            <a href={props.tooltipImage} target={'blank'}>
                                <img
                                    style={{
                                        width: '240px',
                                        height: '100%',
                                    }}
                                    src={props.tooltipImage}
                                />
                            </a>
                        )}
                    </TooltipContent>
                )}
            </TooltipWrapper>
        </a>
    )
}

export default STooltip
